<template>
  <div>
    <v-alert dense border="bottom" type="primary" icon="mdi-information"
      >ENGINEER SOLUTION</v-alert
    >
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <span class="caption">Branch :</span>
            <span class="caption">{{ information.branch_name }}</span>
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <span class="caption">Engineer :</span>
            <span class="caption">{{ information.engineer_name }}</span>
          </v-col>
          <v-col cols="6" sm="3" md="3">
            <span class="caption">Solution :</span>
            <span class="caption">{{ information.solution }}</span>
          </v-col>
          <v-col cols="6" sm="3" md="5">
            <div v-for="(item, index) in information.parts" :key="index">
              <span
                >{{ index + 1 }}.
                {{ item.part_name + " " + item.part_description }}</span
              >
              <span>{{ " " + item.ce_status }}</span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: ["information", "condition"],
  data() {
    return {};
  },
};
</script>
